import { useState, useCallback } from 'react';
import { syncKey } from './dbService';

export function useStorage(key, def) {
  const [val, setVal] = useState(() => {
    try { const r = localStorage.getItem(key); return r !== null ? JSON.parse(r) : def; }
    catch { return def; }
  });

  const set = useCallback(v => {
    setVal(prev => {
      const next = typeof v === 'function' ? v(prev) : v;
      try { localStorage.setItem(key, JSON.stringify(next)); } catch {}
      // Fire-and-forget DB sync — never blocks the UI
      try { syncKey(key, next); } catch {}
      return next;
    });
  }, [key]);

  return [val, set];
}

// Like useStorage but starts with `def` instead of reading from localStorage.
// Writes still propagate to localStorage (for child screens) and DB via syncKey.
// Use this for all user-data fields so initial state always comes from the DB.
export function useDbField(key, def) {
  const [val, setVal] = useState(def);

  const set = useCallback(v => {
    setVal(prev => {
      const next = typeof v === 'function' ? v(prev) : v;
      try { localStorage.setItem(key, JSON.stringify(next)); } catch {}
      try { syncKey(key, next); } catch {}
      return next;
    });
  }, [key]);

  return [val, set];
}
